module.exports = __webpack_public_path__ + "img/icon-goal-1.f85da486.svg";